import { saveAs } from 'file-saver'
import { treeToIndentedList, indentedListToTree } from '../../store/migrations/data-structure-conversion'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import { setNodes } from '../../controllers/treeEngine'

const ImportExportComponent = ({ nodes }) => {
    const history = useHistory()

    const importData = (event) => {
        const file = event.target.files[0]

        const reader = new FileReader()
        reader.onload = (event) => {
            const text = event.target.result
            const nodes = JSON.parse(text)
            const tree = indentedListToTree(nodes)
            setNodes(tree)
            history.push('/')
        }

        reader.readAsText(file)
    }

    const exportData = () => {
        const indentedList = treeToIndentedList(nodes)
        const str = JSON.stringify(indentedList, null, 4)
        const fileName = `treelist_export_${new Date().toISOString()}.json`
        const file = new File([str], fileName, {
            type: 'application/json;charset=utf-8'
        })

        saveAs(file)
    }

    return (
        <>
            <h2>Import &amp; Export</h2>
            <input onChange={importData} type="file" id="myfile" name="myfile" />
            <br />
            <br />
            <button id="export-button" onClick={exportData}>
                Download list data
            </button>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        nodes: state.nodes
    }
}

export const ImportExport = connect(mapStateToProps)(ImportExportComponent)
